import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLenis, scrollToSection } from "@/App";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { StatsBar } from "@/components/StatsBar";
import { Manifesto } from "@/components/Manifesto";
import { Records } from "@/components/Records";
import { Singles } from "@/components/Singles";
import { FreeTip } from "@/components/FreeTip";
import { About } from "@/components/About";
import { Plans } from "@/components/Plans";
import { Contact } from "@/components/Contact";
import { CookieBanner } from "@/components/CookieBanner";
import { Footer } from "@/components/Footer";

export default function HomePage() {
    const lenisRef = useLenis();
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.slice(1);
            const t = setTimeout(() => scrollToSection(lenisRef.current, id), 450);
            return () => clearTimeout(t);
        }
    }, [location.key]);

    return (
        <main>
            <Navbar />
            <Hero />
            <Marquee />
            <StatsBar />
            <Singles />
            <Records />
            <FreeTip />
            <Manifesto />
            <About />
            <Plans />
            <Contact />
            <Footer />
            <CookieBanner />
        </main>
    );
}
